<template>
  <div class="artistas">
    <!-- Artistas -->
    <ArtistsCarrousel
      :has-no-desktop-slider="true"
      :artists="artistsData"
      class="artists-carousel-component"
    />
    <UpcomingAuctions />
  </div>
</template>
<script>
import ArtistsCarrousel from '@/components/ArtistsCarrousel/ArtistsCarrousel.vue';
import UpcomingAuctions from '@/components/UpcomingAuctions/UpcomingAuctions.vue';

export default {
  name: 'Artistas',
  components: { ArtistsCarrousel, UpcomingAuctions },
  data() {
    return {
      artistsData: [
        {
          name: 'ANA HOLCK',
          img: require('../../assets/artists-carrousel-1.png'),
          goToIndex: 1,
        },
        {
          name: 'ANDRÉ PENTEADO',
          img: require('../../assets/artists-carrousel-2.png'),
          goToIndex: 1,
        },
        {
          name: 'ANDRÉ FELICIANO',
          img: require('../../assets/artists-carrousel-3.png'),
          goToIndex: 1,
        },
        {
          name: 'CAMILA SOATO',
          img: require('../../assets/artists-carrousel-4.png'),
          goToIndex: 1,
        },
        {
          name: 'CAMILLE KACHANI',
          img: require('../../assets/artists-carrousel-5.png'),
          goToIndex: 1,
        },
        {
          name: 'CAROLINA PONTE',
          img: require('../../assets/artists-carrousel-6.png'),
          goToIndex: 1,
        },
        {
          name: 'CAMILLE KACHANI',
          img: require('../../assets/artists-carrousel-5.png'),
          goToIndex: 1,
        },
        {
          name: 'CAROLINA PONTE',
          img: require('../../assets/artists-carrousel-6.png'),
          goToIndex: 1,
        },
      ],
    };
  },
  methods: {
    gotoLeilao(n) {
      this.$router.push({
        name: this.$consts.ROUTES.LEILOES.NAME,
        params: {
          leilao: n,
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.artists-carousel-component {
  margin-top: 140px;
}
</style>
